import type { Field, Form, InitialValueInput } from './magicalFormsTypes';

export function setFormValues<TField extends Field>(
  form: Form<TField>,
  values:
    | InitialValueInput<TField>
    | ((values: Form<TField>['value']) => InitialValueInput<TField>),
  options: {
    touched: boolean;
  } = { touched: true }
): void {
  function getValues(): InitialValueInput<TField> {
    if (typeof values === 'function') {
      // https://github.com/microsoft/TypeScript/issues/46066#issuecomment-1093209502
      // @ts-expect-error - This is a hack to get around the fact that the type of values is not known at this point
      return values(form.value);
    }

    return values;
  }

  const newState = Object.entries(getValues()).reduce((result, entry) => {
    const [key, value] = entry;

    result[key] = {
      value: value,
      touched: options.touched,
    };

    return result;
  }, {} as InitialValueInput<TField>);

  if (form._field.kind !== 'object') {
    throw new Error('Form must be an object');
  }

  form.setState({
    ...form.state,
    ...newState,
  });
}
